import React from 'react';
import {
	styled,
	Button
} from 'ps-gui';

import {
	getFormItemLabel,
	getPhrase
} from '../../../data/phrases';

export default class Result extends React.PureComponent {
	render() {
		const {data, showLoginForm} = this.props;
		const {type, displayName, userName} = data.toJS();

		return (
			<>
				<h1>{type === 'PASSWORD_CHANGE' ? getPhrase('passwordHasBeenChanged') : getPhrase('activationSuccessful')}</h1>
				<h2>{getPhrase('nowYouCanLogIn')}</h2>
				{
					type !== 'PASSWORD_CHANGE' &&
					<UserInfo>
						<Item>
							<span className="label">{getFormItemLabel('nameAndSurname')}:</span>
							<span className="value">{displayName}</span>
						</Item>
						<Item>
							<span className="label">{getFormItemLabel('userName')}:</span>
							<span className="value">{userName}</span>
						</Item>
					</UserInfo>

				}
				<Button
					text={getPhrase('login')}
					onAction={showLoginForm}
				/>
			</>
		);
	}
}

const UserInfo = styled.div`
	margin-bottom: 40px;
	margin-top: 24px;
`;

const Item = styled.div`
	.label {
		display: inline-block;
		color: ${props => props.theme.disabledTextColor};
		font-size: 16px;
		font-weight: 400;
		line-height: 30px;
		min-width: 200px;
	}
	.value {
		font-size: 16px;
		font-weight: 700;
		line-height: 30px;
	}
`;
